var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7128,
    height: 7128,
    viewBox: "0 0 7128 7128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_379_392)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_392)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 7000,
    height: 7000,
    rx: 15.859,
    fill: "#6BC4D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-282.67 4255.34C842.238 3706.12 3092.05 2264.44 3574.16 938.174C3574.16 938.174 3895.56 167.419 3574.16 39.4533C3156.16 -126.971 2288.55 2457.89 2127.85 4704.7C1967.15 6951.5 3734.86 7379.01 8073.79 6030.93",
    stroke: "white",
    strokeWidth: 400
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_379_392",
    x: 0.563877,
    y: 0.563877,
    width: 7126.87,
    height: 7126.87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.7181
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_379_392"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_379_392",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_392"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 64,
    width: 7000,
    height: 7000,
    rx: 15.859,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.12549355cb3b7ae55831602c711e5c76.svg";
export { ForwardRef as ReactComponent };